import React from 'react';
import PropTypes from 'prop-types';
import RentalInputsContext from './RentalInputsContext';

const RentalInputsProvider = ({ children }) => {
    const [rentalInputs, setRentalInputs] = React.useState(null);

    React.useEffect(() => {
        // Client-side only
        if (typeof window !== 'undefined') {
            const params = new URLSearchParams(window.location.search);

            const getFormattedDate = (offsetDays = 0) => {
                const date = new Date();
                date.setDate(date.getDate() + offsetDays);
                return date.toISOString().split('T')[0];
            };

            setRentalInputs({
                trip_type: params.get('trip_type') || '',
                product_title: params.get('product_title') || '',
                start_city: params.get('start_city') || '',
                end_city: params.get('end_city') || '',
                add_ons_charge : 0,
                trip_hours: params.get('trip_hours') || '8',
                start_date: params.get('start_date') || getFormattedDate(1),
                end_date: params.get('end_date') || getFormattedDate(3)
            });
        }
    }, []);

    const contextValue = React.useMemo(() => ({ rentalInputs, setRentalInputs }), [rentalInputs]);

    if (!rentalInputs) return null;

    return (
        <RentalInputsContext.Provider value={contextValue}>
            {children}
        </RentalInputsContext.Provider>
    );
};

RentalInputsProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export default RentalInputsProvider;